import { RefBool } from '@tblabs/truffle';
import { SelectableCollection } from './SelectableCollection';


export class SelectableItem<T>
{
   
    public IsSelected = new RefBool(false);
    public Item: T;
    public FromCollection: SelectableCollection<T>;

    constructor(item: T, fromCollection: SelectableCollection<T>)
    {
        this.Item = item;
        this.FromCollection = fromCollection;
    } 
    
    public SelfSelect(): void
    {
        this.FromCollection.Select(this);
    }

    public RemoveSelf(): void
    {
        this.FromCollection.Remove(this);
    }
}
